export const defaultNone = {
	create: 'none',
	read: 'none',
	update: 'none',
	delete: 'none',
	comment: 'none',
	explain: 'none',
	status_blacklist: [],
	read_field_blacklist: [],
	write_field_blacklist: []
};

export const defaultFull = {
	create: 'full',
	read: 'full',
	update: 'full',
	delete: 'full',
	comment: 'full',
	explain: 'full',
	status_blacklist: [],
	read_field_blacklist: [],
	write_field_blacklist: []
};
